import { Button, CircularProgress, DialogContent, Table, TableCell, TableContainer, TableRow } from "@material-ui/core"
import DialogComponent from "../../../../../../components/Dialog"
import { Get } from "../../../../../../actions"
import { format } from "../../../../../../heplers/format"
import dayjs from "dayjs"
import { useSnackbar } from "notistack"
import { useState } from "react"

export const MeetingActionsDialog=({meeting,onClose})=>{
    const [submitting,setSubmitting]=useState(false)
    const {enqueueSnackbar}=useSnackbar()
    const handleReportDataCollectionClick=(url)=>{
        setSubmitting(true)
        Get(
            {meetingId:meeting.id},
            url,
            null,
            resp=>{
                enqueueSnackbar("The Service executed successfully",{variant:"success"})
        setSubmitting(false)
    },
            error=>{
                enqueueSnackbar("The Service had encountered an error",{variant:"error"})
                setSubmitting(false)

            }
        )
    }
    
    return <DialogComponent open={meeting!=null} title="Actions" onClose={onClose}>
    <DialogContent>
      <TableContainer>
        <Table>
          <TableRow>
            <TableCell style={{color:dayjs(meeting?.reportDataCollectionCronDate).year()!=1901  ? "green":""}}>Report Data Collection</TableCell>
            <TableCell style={{color:dayjs(meeting?.reportDataCollectionCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.reportDataCollectionCronDate)=="-"?"Not Sent Yet":format("date",meeting?.reportDataCollectionCronDate)}</TableCell>
            <TableCell>
              {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/ReportDataCollectionRequestByMeeting")}>{dayjs(meeting?.reportDataCollectionCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{color:dayjs(meeting?.askForAgendaCronDate).year()!=1901  ? "green":""}}>Ask for agenda</TableCell>
            <TableCell style={{color:dayjs(meeting?.askForAgendaCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.askForAgendaCronDate)=="-"?"Not Sent Yet":format("date",meeting?.askForAgendaCronDate)}</TableCell>
            <TableCell>
            {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/AskingAgendaByMeeting")}>{dayjs(meeting?.askForAgendaCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{color:dayjs(meeting?.askForDocumentCronDate).year()!=1901  ? "green":""}}>Ask for document</TableCell>
            <TableCell style={{color:dayjs(meeting?.askForDocumentCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.askForDocumentCronDate)=="-"?"Not Sent Yet":format("date",meeting?.askForDocumentCronDate)}</TableCell>
            <TableCell>
            {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/AskingMeetingDocumentsByMeeting")}>{dayjs(meeting?.askForDocumentCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}

            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Reminders</TableCell>
            <TableCell style={{color:dayjs(meeting?.remindersCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.remindersCronDate)=="-"?"Not Sent Yet":format("date",meeting?.remindersCronDate)}</TableCell>
            <TableCell>
            {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/SendMeetingReminderEmailbyMeeting")}>{dayjs(meeting?.remindersCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}

            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Invitations</TableCell>
            <TableCell style={{color:dayjs(meeting?.invitationsCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.invitationsCronDate)=="-"?"Not Sent Yet":format("date",meeting?.invitationsCronDate)}</TableCell>
            <TableCell>
            {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/SendMeetingInvitationMailByMeeting")}>{dayjs(meeting?.invitationsCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}

            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Calendar</TableCell>
            <TableCell style={{color:dayjs(meeting?.calendarCronDate).year()!=1901  ? "green":""}}>{format("date",meeting?.calendarCronDate)=="-"?"Not Sent Yet":format("date",meeting?.calendarCronDate)}</TableCell>
            <TableCell>
            {submitting?<CircularProgress size="12px"/>: <Button variant="contained" onClick={()=>handleReportDataCollectionClick("Cron/SendCalendarByMeeting")}>{dayjs(meeting?.calendarCronDate).year()==1901 ?"Initiate":"Resend"}</Button>}

            </TableCell>
          </TableRow>
        </Table>
      </TableContainer>
    </DialogContent>
  </DialogComponent>
}